export const GLOBAL_DATA = "GLOBAL_DATA";
export const DELETE_DATA = "DELETE_DATA";
export const GLOBAL_STEPPER_DATA = "GLOBAL_STEPPER_DATA";
export const DELETE_STEPPER_DATA = "DELETE_STEPPER_DATA";
export const SET_ORGANISATION_DROPDOWN_VALUES =
  "SET_ORGANISATION_DROPDOWN_VALUES";
export const SET_EMPLOYEE_DROPDOWN_VALUES = "SET_EMPLOYEE_DROPDOWN_VALUES";
export const SET_ORGANISATION_UPLOAD_FILES = "SET_ORGANISATION_UPLOAD_FILES";
export const SET_EMPLOYEE_UPLOAD_FILES = "SET_EMPLOYEE_UPLOAD_FILES";
export const TOGGLE_GROWING_LIST_POPUP = "TOGGLE_GROWING_LIST_POPUP";
export const ACCESS_PERMISSION = "ACCESS_PERMISSION";
export const SEARCH_VALUE = "SEARCH_VALUE";
